import { Component, OnInit, Input } from '@angular/core';
import { Global } from "../classes/Global";

@Component({
  selector: 'app-small-flags',
  templateUrl: './small-flags.component.html',
  styleUrls: ['./small-flags.component.scss']
})
export class SmallFlagsComponent implements OnInit {

  @Input() flags: string;
  flagArray: Array<string> = [];

  constructor() { }

  ngOnInit() {

    if(this.flags == null) {
      return "";
    }

    this.flagArray = this.flags.split(',').map(function(item) {
      return item.trim();
    });

  }

  getIconUrl(countryCode: string): string {

    if(countryCode == "en"){
      countryCode = "us";
    }

    if(Object.keys(Global.countries).indexOf(countryCode) != -1) {
      return Global.countries[countryCode].icon;
    }
    return "";
    
  }

}
